import Dropzone from 'react-dropzone';
import styled from 'styled-components';
import { Button, Divider } from '@mui/material';
import { useAppDispatch } from '../../app/hooks';
import { showErrorSnackbar } from '../../features/snackbar/snackbarSlice';
import { IMedia } from '../../types/worksheet';

const DEFAULT_ACCEPT = {
  'image/jpeg': ['.jpeg', '.jpg'],
  'image/png': ['.png'],
  'application/pdf': ['.pdf'],
};

const UploadDropzone = (props: ChildProps) => {
  const { onFilesAdded, maxFileSize = 5242880, minHeight = '160px', accept } = props;
  const storeDispatch = useAppDispatch();

  const handleDrop = (acceptedFiles: any[]) => {
    if (acceptedFiles.length === 0) {
      storeDispatch(showErrorSnackbar('This file type is not allowed'));
      return;
    }
    const oversizedFile = acceptedFiles.find((file) => file.size > maxFileSize);
    if (oversizedFile) {
      storeDispatch(showErrorSnackbar('This file is too large'));
      return;
    }

    const newFiles: IMedia[] = [];
    let readCount = 0;
    acceptedFiles.forEach((file) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);
      fileReader.onloadend = () => {
        newFiles.push({ name: file.name, file, url: fileReader.result as string });
        readCount += 1;
        if (readCount === acceptedFiles.length) {
          onFilesAdded(newFiles);
        }
      };
    });
  };

  return (
    <DropzoneArea style={{ minHeight }}>
      <Dropzone onDrop={handleDrop} accept={accept ?? DEFAULT_ACCEPT}>
        {({ getRootProps, getInputProps }) => (
          <div style={{ height: '100%' }} {...getRootProps()}>
            <input {...getInputProps()} />
            <InsideText>
              Drag and drop your file
              <Divider sx={{ margin: '10px 0' }}>or</Divider>
              <Button sx={{ borderRadius: 2, textTransform: 'none', fontWeight: 600 }} disableElevation variant="contained">
                Browse
              </Button>
            </InsideText>
          </div>
        )}
      </Dropzone>
    </DropzoneArea>
  );
};

interface ChildProps {
  onFilesAdded: (files: IMedia[]) => void;
  maxFileSize?: number;
  minHeight?: number | string;
  accept?: Record<string, string[]>;
}

const InsideText = styled.div`
  text-align: center;
  color: #666666;
  padding-top: 10px;
`;

const DropzoneArea = styled.div`
  padding: 20px;
  height: 100%;
  box-sizing: border-box;
  border: 1px dashed #c4c4c4;
  border-radius: 8px;
  background-color: #fafbfc;
  transition: border-color 0.2s ease, background-color 0.2s ease;
  &:hover {
    border-color: #002044;
    background-color: #f4f6f9;
  }
`;

export default UploadDropzone;
